module.exports = __webpack_public_path__ + "img/6f_r_tokiwa.968c21e9.png";